"use client";

import { useAuth } from "@/contexts/AuthContext";
import { LogOut, User, Menu, X } from "lucide-react";
import Link from "next/link";
import { useState } from "react";

export default function Header() {
  const { user, logout } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="bg-primary text-white shadow-lg sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link href="/" className="flex items-center gap-3">
            <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center">
              <span className="text-primary font-bold text-sm">IQ</span>
            </div>
            <div>
              <h1 className="text-lg font-bold leading-tight">IQUAMA</h1>
              <p className="text-xs text-green-200 leading-tight">
                Licenciamento Digital - Aracati
              </p>
            </div>
          </Link>

          <nav className="hidden md:flex items-center gap-6">
            <Link href="/" className="text-sm hover:text-green-200 transition">
              Início
            </Link>
            {user && (
              <>
                <Link
                  href="/dashboard"
                  className="text-sm hover:text-green-200 transition"
                >
                  Meus Alvarás
                </Link>
                {user.tipo === "admin" && (
                  <Link
                    href="/admin"
                    className="text-sm hover:text-green-200 transition"
                  >
                    Painel Admin
                  </Link>
                )}
              </>
            )}
          </nav>

          <div className="hidden md:flex items-center gap-4">
            {user ? (
              <div className="flex items-center gap-3">
                <div className="flex items-center gap-2 bg-primary-dark px-3 py-1.5 rounded-full">
                  <User size={14} />
                  <span className="text-sm">{user.nome}</span>
                </div>
                <button
                  onClick={logout}
                  className="p-2 hover:bg-primary-dark rounded-full transition"
                  title="Sair"
                >
                  <LogOut size={18} />
                </button>
              </div>
            ) : (
              <Link
                href="/login"
                className="bg-white text-primary px-4 py-2 rounded-lg text-sm font-semibold hover:bg-green-50 transition"
              >
                Entrar
              </Link>
            )}
          </div>

          <button
            className="md:hidden p-2"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            {menuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-green-700 px-4 py-4 space-y-3">
          <Link href="/" className="block text-sm" onClick={() => setMenuOpen(false)}>
            Início
          </Link>
          {user ? (
            <>
              <Link href="/dashboard" className="block text-sm" onClick={() => setMenuOpen(false)}>
                Meus Alvarás
              </Link>
              {user.tipo === "admin" && (
                <Link href="/admin" className="block text-sm" onClick={() => setMenuOpen(false)}>
                  Painel Admin
                </Link>
              )}
              <button onClick={() => { logout(); setMenuOpen(false); }} className="text-sm text-red-200">
                Sair
              </button>
            </>
          ) : (
            <Link href="/login" className="block text-sm font-semibold" onClick={() => setMenuOpen(false)}>
              Entrar
            </Link>
          )}
        </div>
      )}
    </header>
  );
}
